import xpcConfig from 'vue-xpc/src/config';
export default {
  props: {
    placeholder: String,
    emptyPlaceholder: {
      type: String,
      default: ''
    }
  },
  computed: {
    computedEmptyPlaceholder () {
      return this.emptyPlaceholder || xpcConfig.get('emptyPlaceholder');
    },
    computedSelectPlaceholder () {
      if (this.placeholder && !this.computedDisabled) {
        return this.placeholder;
      } else {
        return this.computedDisabled
          ? this.computedEmptyPlaceholder
          : this.$tx('请选择', 'xpc.common.pleaseSelect');
      }
    },
    computedInputPlaceholder () {
      if (this.placeholder && !this.computedDisabled) {
        return this.placeholder;
      } else {
        return this.computedDisabled
          ? this.computedEmptyPlaceholder
          : this.$tx('请输入', 'xpc.form.pleaseEnter');
      }
    },
    computedDefaultPlaceholder () {
      return this.computedDisabled
        ? this.computedEmptyPlaceholder
        : this.$tx('请选择', 'xpc.common.pleaseSelect');
    },
    computedStartPlaceholder () {
      if (this.startPlaceholder && !this.computedDisabled) {
        return this.startPlaceholder;
      } else {
        return this.computedDefaultPlaceholder;
      }
    },
    computedEndPlaceholder () {
      if (this.endPlaceholder && !this.computedDisabled) {
        return this.endPlaceholder;
      } else {
        return this.computedDefaultPlaceholder;
      }
    }
  }
}



// WEBPACK FOOTER //
// ./~/vue-xpc/src/components/form/placeholder.js